import React, { useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLanguage } from './LanguageContext';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Apply() {
	const [formSelected, setFormSelected] = useState(false);
	const [formType, setFormType] = useState('');
	const [, setLoading] = useState(false);
	const { language } = useLanguage();
	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true);
		if (language === 'en') {
			toast.info('Sending your message...', {
				position: 'top-right',
				autoClose: false,
				closeOnClick: false,
			});
		} else {
			toast.info('Đang gửi...', {
				position: 'top-right',
				autoClose: false,
				closeOnClick: false,
			});
		}

		const form = e.target;

		emailjs
			.sendForm(
				'service_41uzv8j',
				'template_67qu3gn',
				form,
				'3FD0gMPFOva0V7bna',
			)
			.then(
				(response) => {
					//   console.log('SUCCESS!', response.status, response.text);
					toast.dismiss();
					if (language === 'en') {
						toast.success('Message sent successfully!', {
							position: 'top-right',
							autoClose: 5000,
						});
					} else {
						toast.success('Đã gửi thành công!', {
							position: 'top-right',
							autoClose: 5000,
						});
					}
					form.reset();
				},
				(error) => {
					if (language === 'en') {
						toast.error(
							'Sorry, error occur please send direct message in contact',
							{
								position: 'top-right',
								autoClose: 5000,
							},
						);
					} else {
						toast.error(
							'Đã có lỗi khi gửi, xin vui lòng sử dụng thông tin trong liên hệ',
							{
								position: 'top-right',
								autoClose: 5000,
							},
						);
					}
				},
			)
			.finally(() => {
				setLoading(false);
			});
	};

	function handleFormSelect(type) {
		setFormSelected(true);
		setFormType(type);
	}

	function handleGoBack() {
		setFormSelected(false);
		setFormType('');
	}

	return (
		<>
			<ToastContainer />

			{language === 'en' ? (
				<>
					{!formSelected ? (
						<div className='flex flex-col items-center space-y-10 pt-5'>
							<h1 className='text-darkBrown text-5xl arial'>Apply</h1>
							<div className='flex flex-col items-center space-y-5 w-1/2'>
								<button
									className='w-full max-w-xs rounded-full bg-darkBrown text-white py-2 avenir'
									onClick={() => handleFormSelect('resident')}>
									Resident Artist
								</button>
								<button
									className='w-full max-w-xs rounded-full bg-darkBrown text-white py-2 avenir'
									onClick={() => handleFormSelect('guest')}>
									Guest Artist
								</button>
							</div>
						</div>
					) : (
						<>
							<div className='flex'>
								<button onClick={handleGoBack}>
									<FaArrowLeft className='text-darkBrown text-4xl flex-none' />
								</button>
								<h1 className='text-2xl font-extrabold text-darkBrown text-center  flex-auto mr-10 arial-bold'>
									Apply
								</h1>
							</div>
							{formType === 'resident' ? (
								<form
									onSubmit={handleSubmit}
									encType='multipart/form-data'
									className='flex flex-col items-center space-y-8 text-darkBrown cochin'>
									<h2 className='text-2xl arial-bold'>Resident Artist</h2>
									<p className='text-center'>
										Please fill in your information in the form below
									</p>
									<div className='flex flex-col'>
										<input type='hidden' name='type' value='resident' />
										<input type='hidden' name='start' value='Không Có' />
										<input type='hidden' name='end' value='Không Có' />

										<label>Full name</label>
										<input
											name='name'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>E-mail</label>
										<input
											name='email'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Your Instagram or URL</label>
										<input
											name='social'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Address</label>
										<input
											name='address'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Age</label>
										<input
											name='age'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Message</label>
										<p>(Tell us about yourself and your work)</p>
										<input
											name='message'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>

									<div>
										<button
											type='submit'
											className='text-white bg-brown text-4xl  px-8 py-4 rounded-3xl avenir'>
											Send
										</button>
									</div>
								</form>
							) : (
								<form
									onSubmit={handleSubmit}
									encType='multipart/form-data'
									className='flex flex-col items-center space-y-8 text-darkBrown cochin'>
									<h2 className='text-2xl font-semibold arial-bold'>
										Guess Artist
									</h2>
									<p className='text-center'>
										Please fill in your information in the form below
									</p>
									<input type='hidden' name='type' value='guess' />
									<div className='flex flex-col'>
										<label>Full name</label>
										<input
											name='name'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>E-mail</label>
										<input
											name='email'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Your Instagram or URL</label>
										<input
											name='social'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Where are you from</label>
										<input
											name='address'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Age</label>
										<input
											name='age'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Start date</label>
										<input
											name='start'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>End date</label>
										<input
											name='end'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Message</label>
										<p>(Tell us about yourself and your work)</p>
										<input
											name='message'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div>
										<button className='text-white bg-brown text-4xl  px-8 py-4 rounded-3xl avenir'>
											Send
										</button>
									</div>
								</form>
							)}
						</>
					)}
				</>
			) : (
				<>
					{!formSelected ? (
						<div className='flex flex-col items-center space-y-10 pt-5'>
							<h1 className='text-darkBrown text-5xl arial'>Đăng ký</h1>
							<div className='flex flex-col items-center space-y-5 w-1/2'>
								<button
									className='w-full max-w-xs rounded-full bg-darkBrown text-white py-2 avenir'
									onClick={() => handleFormSelect('resident')}>
									Artist Thường Trú
								</button>
								<button
									className='w-full max-w-xs rounded-full bg-darkBrown text-white py-2 avenir'
									onClick={() => handleFormSelect('guest')}>
									Artist Khách Mời
								</button>
							</div>
						</div>
					) : (
						<>
							<div className='flex'>
								<button onClick={handleGoBack}>
									<FaArrowLeft className='text-darkBrown text-4xl flex-none' />
								</button>
								<h1 className='text-2xl font-extrabold text-darkBrown text-center  flex-auto mr-10 arial-bold'>
									Đăng Ký
								</h1>
							</div>
							{formType === 'resident' ? (
								<form
									onSubmit={handleSubmit}
									encType='multipart/form-data'
									className='flex flex-col items-center space-y-8 text-darkBrown cochin'>
									<h2 className='text-2xl arial-bold'>Artist Thường Trú</h2>
									<p className='text-center'>Hãy Điền Vào Đơn</p>
									<div className='flex flex-col'>
										<input type='hidden' name='type' value='resident' />
										<input type='hidden' name='start' value='Không Có' />
										<input type='hidden' name='end' value='Không Có' />
										<label>Họ và Tên</label>
										<input
											name='name'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>E-mail</label>
										<input
											name='email'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Instagram hoặc các mạng xã hội</label>
										<input
											name='social'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Địa chỉ</label>
										<input
											name='address'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Tuổi</label>
										<input
											name='age'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Lời nhắn</label>
										<p>(Hãy nói về bạn)</p>
										<input
											name='message'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>

									<div>
										<button
											type='submit'
											className='text-white bg-brown text-4xl  px-8 py-4 rounded-3xl avenir'>
											Gửi
										</button>
									</div>
								</form>
							) : (
								<form
									onSubmit={handleSubmit}
									encType='multipart/form-data'
									className='flex flex-col items-center space-y-8 text-darkBrown cochin'>
									<h2 className='text-2xl font-semibold arial-bold'>
										Artist Khách Mời
									</h2>
									<p className='text-center'>Hãy Điền Vào Đơn</p>
									<input type='hidden' name='type' value='guess' />
									<div className='flex flex-col'>
										<label>Họ và Tên</label>
										<input
											name='name'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>E-mail</label>
										<input
											name='email'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Instagram hoặc các mạng xã hội</label>
										<input
											name='social'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Địa chỉ</label>
										<input
											name='address'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Tuổi</label>
										<input
											name='age'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Ngày bắt đầu</label>
										<input
											name='start'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Ngày kết thúc</label>
										<input
											name='end'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div className='flex flex-col'>
										<label>Lời nhắn</label>
										<p>(Hãy nói về bạn)</p>
										<input
											name='message'
											type='text'
											className='border border-darkBrown w-72 p-2'
										/>
									</div>
									<div>
										<button className='text-white bg-brown text-4xl  px-8 py-4 rounded-3xl avenir'>
											Gửi
										</button>
									</div>
								</form>
							)}
						</>
					)}
				</>
			)}
		</>
	);
}

export default Apply;
